import { useTrackingVirtualPageView } from '@/composables/useTrackingVirtualPageView';
import { trackEvent } from '@/helpers/GTM/GTMHelper';
import { trackingClickEvent, trackingFeatureDisplayEvent } from '@/tracking/tracking';
import {
  TRACKING_ACTION,
  TRACKING_CATEGORY,
  TRACKING_LABEL,
  VirtualPageViewProps,
} from '@/tracking/types';
import { convertTreatmentsToTrackingString } from '@smg-real-estate/vue-experiments';
import { useStore } from 'vuex';

export function useTrackingWithTreatment() {
  const store = useStore();
  const { trackVirtualPageView } = useTrackingVirtualPageView();

  /** Read split treatments at call time so async Vuex updates are not missed. */
  function getTreatmentTrackingParams(): Record<string, string> {
    const treatments = store.state?.split?.treatments ?? {};
    if (Object.keys(treatments).length === 0) {
      return {};
    }
    return {
      h_experiment_split_treatments_107: convertTreatmentsToTrackingString(treatments),
    };
  }

  function trackVirtualPageViewWithTreatment({
    subType,
    locale,
    stepInputs,
    moreParams,
  }: VirtualPageViewProps): void {
    const additionalParams = {
      ...getTreatmentTrackingParams(),
      ...moreParams,
    };

    trackVirtualPageView({
      subType,
      locale,
      stepInputs,
      ...(Object.keys(additionalParams).length && { moreParams: additionalParams }),
    });
  }

  function trackClickEventWithTreatment(action: TRACKING_ACTION, label: TRACKING_LABEL): void {
    trackingClickEvent(action, label, true, getTreatmentTrackingParams());
  }

  function trackFeatureDisplayWithTreatment(action: string, label: string): void {
    trackingFeatureDisplayEvent(action, label, getTreatmentTrackingParams());
  }

  function trackCtaClickWithTreatment(params: Record<string, string>): void {
    trackEvent(TRACKING_CATEGORY.CTA_CLICK, {
      ...params,
      ...getTreatmentTrackingParams(),
    });
  }

  return {
    getTreatmentTrackingParams,
    trackVirtualPageViewWithTreatment,
    trackClickEventWithTreatment,
    trackFeatureDisplayWithTreatment,
    trackCtaClickWithTreatment,
  };
}
